import { render, staticRenderFns } from "./IntegratedSettlementDetailView.vue?vue&type=template&id=06600684&scoped=true"
import script from "./IntegratedSettlementDetailView.vue?vue&type=script&lang=js"
export * from "./IntegratedSettlementDetailView.vue?vue&type=script&lang=js"
import style0 from "./IntegratedSettlementDetailView.vue?vue&type=style&index=0&id=06600684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06600684",
  null
  
)

export default component.exports